<template>
  <div v-if="pagename" id="app">
    <Layout>
      <router-view :key="key" />
    </Layout>
  </div>
  <div v-else id="app">
    <router-view :key="key" />
  </div>
</template>

<script>
import Layout from './views/layout/Layout.vue'
export default {
  name: 'App',
  components: {
    Layout
  },
  computed: {
    pagename: {
      get: function() {
        return this.$route.name !== 'Login' && this.$route.name !== 'taskDetail'
      },
      set: function() {
      }
    },
    key() {
      return this.$route.name + new Date()
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'Login') {
        this.pagename = false
      } else {
        this.pagename = true
      }
    }
  },
  mounted() {
    // 解决IE跳转不了router
    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
      window.addEventListener(
        'hashchange',
        () => {
          var currentPath = window.location.hash.slice(1)
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath)
          }
        },
        false
      )
    }
  }
}
</script>
